import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, renderSlot as _renderSlot, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", { class: "text-left font-semibold" }, " Total ", -1)
const _hoisted_2 = [
  _hoisted_1
]

import { tail } from 'lodash';

import { ColumnDefinition, Sticky } from './BalTable.vue';

type Props = {
  isColumnStuck?: boolean;
  onRowClick: (data: any) => void;
  sticky?: Sticky;
  columns: ColumnDefinition<any>[];
};


export default _defineComponent({
  props: {
    isColumnStuck: { type: Boolean, required: false },
    onRowClick: { type: Function, required: true },
    sticky: { type: null, required: false },
    columns: { type: Array, required: true }
  } as unknown as undefined,
  setup(__props: {
  isColumnStuck?: boolean;
  onRowClick: (data: any) => void;
  sticky?: Sticky;
  columns: ColumnDefinition<any>[];
}) {

const props = __props


/** FUNCTIONS */
// Need a method for horizontal stickiness as we need to
// check whether the table item belongs in the first column
function getHorizontalStickyClass(index: number) {
  if (index !== 0) return '';
  if (props.sticky === 'horizontal' || props.sticky === 'both') {
    return 'horizontalSticky';
  }
  return '';
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("tbody", null, [
    _createElementVNode("tr", {
      class: _normalizeClass(['row-bg group z-10 bg-white', { 'cursor-pointer': __props.onRowClick }])
    }, [
      _createElementVNode("td", {
        class: _normalizeClass([
          getHorizontalStickyClass(0),
          __props.isColumnStuck ? 'isSticky' : '',
          'border-t bg-white p-6 text-left align-top dark:border-gray-900 dark:bg-gray-850',
        ])
      }, _hoisted_2, 2),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(tail)(__props.columns), (column, columnIndex) => {
        return (_openBlock(), _createElementBlock("td", {
          key: column.id,
          class: _normalizeClass([
          column.align === 'right' ? 'text-left' : 'text-right',
          getHorizontalStickyClass(columnIndex + 1),
          __props.isColumnStuck ? 'isSticky' : '',
          'border-t bg-white p-6 dark:border-gray-900 dark:bg-gray-850',
        ])
        }, [
          (column.totalsCell)
            ? _renderSlot(_ctx.$slots, column.totalsCell, { key: 0 })
            : _createCommentVNode("", true)
        ], 2))
      }), 128))
    ], 2)
  ]))
}
}

})